import React from 'react';
import { AnalyticsPromos } from '../utils/analytics';
import styled from 'styled-components';
import { breakpoints } from '../utils/styles';
import { PictureWithSources } from './common/PictureWithSources';
import { PromoWideFixedType } from '../types/entities';

const ImgDesktop = styled(PictureWithSources)`
    display: none;
    aspect-ratio: 125 / 22;
    @media screen and (min-width: ${props => breakpoints.desktop}px) { display: block !important; }
`;

const ImgMobile = styled(PictureWithSources)`
    aspect-ratio: 219 / 121;
    @media screen and (min-width: ${props => breakpoints.desktop}px) { display: none !important; }
`;

type Props = {
    promo: PromoWideFixedType
};

type State = {
    analytics_setup:boolean
};

class PromoWideFixed extends React.PureComponent<Props, State> {
    private ref:React.RefObject<HTMLAnchorElement> = React.createRef();

    constructor(props:Props) {
        super(props);

        this.onClick = this.onClick.bind(this);
        this.state = { analytics_setup: false };
    }

    componentDidMount() {
        this.setup();
    }
    
    componentDidUpdate() {
        this.setup();
    }

    setup() {
        if (!this.ref.current || this.state.analytics_setup) return;

        this.setState({ analytics_setup: true });
        const { promo } = this.props;
        
        setTimeout(() => {
            AnalyticsPromos.observe('promo_wide', promo.id, promo.name, this.ref.current);
        }, 1500);
    }

    onClick(event:React.MouseEvent<HTMLElement>) {
        const { promo } = this.props;
        const openInNewWindow:boolean = promo.target !== '_self' || event.altKey || event.ctrlKey || event.shiftKey;

        AnalyticsPromos.trackClick('promo_wide', promo.id, promo.name, openInNewWindow ? null : () => {
            document.location = promo.url;
        });

        if (!openInNewWindow) event.preventDefault();
    }

    render() {
        const { promo } = this.props;
        
        if (!promo) {
            return null;
        }

        return <a href={promo.url || '#'} target={promo.target} ref={this.ref} onClick={this.onClick} className='o-ad-w-100'>
            <ImgDesktop 
                images={promo.images && promo.images.image_web ? promo.images.image_web : undefined}
                fallback={promo.image_web_url}
                title={promo.name}
                lazy
            />
            <ImgMobile
                images={promo.images && promo.images.image_app ? promo.images.image_app : undefined}
                fallback={promo.image_app_url}
                title={promo.name}
                lazy
            />
        </a>;
    }
}

export default PromoWideFixed;